import { setEqualHeights, smallDesktopMin } from './util';

const AllInJobs = (() => {
    return {
        init() {
            if(window.innerWidth > smallDesktopMin) {
                setEqualHeights($('.all-in-job-title'), 5);
            }
        }
    }
})();

export default (() => {
    $(document).ready(AllInJobs.init);
    $(window).on('resize', AllInJobs.init);
})();